import { createTableItem } from "../AssetsExpenses/create_table_item";

export const autoInsuranceCostCalcAmt = (carValue, carSize, currentYYYYMM) => {
    //Annual Insurance Cost = Base Rate × Car Value × Risk Multiplier
    //small 0.95, passenger (sedan)1.0,  SUV1.1, truck1.2,  sports1.6

     const baseRate = .05;
     let riskMultiplier = 0;
     switch (+carSize){
        case 100:   // small car
            riskMultiplier = .95;
            break;
        case 200:  // passenger car (sedan)
            riskMultiplier = 1.0;
            break;
        case 300:  // SUV
            riskMultiplier = 1.1;
            break;
        case 400:  // sports car
            riskMultiplier = 1.6;
            break;
        case 500: // truck
            riskMultiplier = 1.2;
            break;
        default:
            break;
     }
     const annualIns = baseRate * +carValue * riskMultiplier;
     const monthlyIns = (annualIns / 12).toFixed(2);
     const expenseString = createTableItem("carIns", "", currentYYYYMM, monthlyIns, "", false);
    
     return expenseString;
 }